class CustomSelect {
    constructor(element) {
        this.element = element;
        this.select = this.element.querySelector("[js-custom-select-select]");
        this.multiple = this.select.hasAttribute("multiple");

        this.select.addEventListener("change", (event) => this.onChange(event));

        this.createSelected();
        this.createItems();

        this.selected.addEventListener("click", (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.selected.nextSibling.classList.toggle("is--hidden");
            this.selected.classList.toggle("is--active");
        });

        document.addEventListener("click", (event) =>
            this.closeAllSelect(event)
        );
    }

    createSelected() {
        this.selected = document.createElement("BUTTON");
        this.selected.classList.add("custom-select__selected");
        this.selected.setAttribute("js-select-selected", "");
        this.selected.innerHTML = this.select.options[
            this.select.selectedIndex
        ].innerHTML;
        this.element.appendChild(this.selected);
    }

    createItems() {
        this.items = document.createElement("DIV");
        this.items.classList.add("custom-select__items");
        this.items.classList.add("is--hidden");
        this.items.setAttribute("js-select-items", "");

        for (let i = 1; i < this.select.length; i++) {
            if (!this.select.options[i].disabled) {
                const item = document.createElement("BUTTON");
                item.classList.add("custom-select__item");
                item.setAttribute("value", this.select.options[i].value);
                item.innerHTML = this.select.options[i].innerHTML;
                item.addEventListener("click", (event) => {
                    event.preventDefault();
                    this.clickSelected(item);
                });
                this.items.appendChild(item);
            }
        }

        this.element.appendChild(this.items);
    }

    clickSelected(item) {
        for (let i = 0; i < this.select.length; i++) {
            if (this.select.options[i].innerHTML == item.innerHTML) {
                if (this.multiple) {
                    this.select.options[i].selected = !this.select.options[i]
                        .selected;
                    item.classList.toggle("is--selected");
                } else {
                    this.select.selectedIndex = i;
                    const selectedItem = item.parentNode.querySelector(
                        ".is--selected"
                    );
                    if (selectedItem)
                        selectedItem.classList.remove("is--selected");
                    item.classList.add("is--selected");
                }
                break;
            }
        }
        this.select.click();
        this.select.dispatchEvent(new Event("change"));
    }

    onChange() {
        if (this.multiple) {
            let selectedValues = "";
            Object.keys(this.select.options).forEach((option) => {
                if (
                    this.select.options[option].selected &&
                    !this.select.options[option].hidden
                )
                    selectedValues += `${this.select.options[option].innerText}, `;
            });

            const values = selectedValues
                ? selectedValues.slice(0, -2)
                : this.select.options[0].innerText;
            this.selected.innerHTML = values;
        } else {
            this.selected.innerHTML = this.select.options[
                this.select.selectedIndex
            ].innerHTML;
        }
    }

    closeAllSelect(event) {
        if (
            this.multiple &&
            this.element === event.target.closest("[js-custom-select]")
        )
            return;
        this.selected.classList.remove("is--active");
        this.items.classList.add("is--hidden");
    }
}

export default CustomSelect;
